import React from 'react';

const ChatBotHistoryConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/upload/chatbothistory',
            component: React.lazy(() => import('./ChatBotHistory'))
        }
    ]
};

export default ChatBotHistoryConfig;